import React from 'react';
import { Box } from '@mui/material';
import { NavBar } from './navbar';

export const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Ensure full height, no more than viewport
        overflowX: 'hidden', // Prevent horizontal scroll
      }}
    >
      <NavBar />
      <Box
        sx={{
          flex: 1, // Fills remaining height
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto', // Allows vertical scroll only if needed
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
